var map = {
	"./shower_products_en_gb.json": 292,
	"./water_products_en_gb.json": 295
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 912;


//////////////////
// WEBPACK FOOTER
// ./src/data ^\.\/.*_products_en_gb\.json$
// module id = 912
// module chunks = 0